import React from 'react';

export const GenericCheckoutHeading = () => {
  return <>To get the scale, buy your first product</>;
};
